import React, { ReactElement } from 'react';

interface AvailableFunctionalityItemProps {
	icon: ReactElement,
	class: string;
	title: string,
	description: string
}

const AvailableFunctionalityItemComponent = (props: AvailableFunctionalityItemProps) => {
	return (
		<div className={`availableFunctionalityItem ${props.class}`}>
			<div className={`availableFunctionalityItem_img`}>
				{props.icon}
			</div>
			<div className="availableFunctionalityItem_data">
				<h3>{props.title}</h3>
				<span>{props.description}</span>
			</div>
		</div>
	);
};

export default AvailableFunctionalityItemComponent;